
import Vue from 'vue'

const getDefaultState = () => {
    return {
        ppe: {
            id: 0,
            idServiceProject: 0,
            idProduct: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async ListByUser(_, idUser) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/ppe/list-by-user/${idUser}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listPpe = result.data.result;

                return listPpe;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list ppe: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/ppe/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get ppe`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get ppe: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, ppeRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`hr/ppe/create-update`, ppeRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (ppeRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, ppeStatusRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`hr/ppe/update-status/${ppeStatusRequest.id}`, ppeStatusRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.ppe, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.ppe;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}